import $ from 'jquery';
//import SCHError from 'SCHError';
//import Auth from '../auth/Auth';
//import {Globs} from '../Globs';

import RestClient from '../rest/RestClient'
import CommonHelper from '../helpers/CommonHelper'
import Config from '../Config'
import ifvisible from "ifvisible.js"
import Entrance from '../pages/Entrance'

var bindings={};
var bindedObtains={};

var OBTAINS = {
  ACCOUNTS:           'accounts',
  STATS:              'stats',
  PROCESS:            'latest_process',
  ACCOUNT_SETS:       'account_settings',
  ACCOUNT_INFO:       'account_info',
  REMOVABLE_ACCOUNTS: 'removable_accounts',
  SHARED_DB:          'shared_db',
  SWITCH_SHARED_DB:   'switch_shared_db',
  USER_TIMEZONE:      'user_timezone',
  USER_INFO:          'user_info',
  AUTOPAY_STATUS:     'autopay_status',
  PURCHASE_ENDTIME:   'purchase_endtime',
};

function _STS(OBTAIN, obj) {

  return obj.__obtains[OBTAIN];
  // var obtains = bindedObtains[OBTAIN];
  //
  // if(CommonHelper.isEmpty(obtains)){
  //   return null;
  // }
  //
  // var sts = obtains[obj];
  //
  // return sts;
}
function _setSTS(OBTAIN, obj, sts) {

  obj.__obtains[OBTAIN] = sts;
  // var obtains = bindedObtains[OBTAIN];
  //
  // if(CommonHelper.isEmpty(obtains)){
  //   obtains = {};
  //   bindedObtains[OBTAIN] = obtains;
  // }

  //var sts = obtains[obj];
  // if(CommonHelper.isEmpty(sts)){
  //   obtains[obj] = sts;
  // }else{
  // }
  // obtains[obj] = sts;
  //
  // console.log(bindedObtains);

}

var Obtainer = {

   firstName:"John",

   myAlert: function() {
       //alert('Obtainer ok');
   },

   mixin:function(destObject){

   	var props	= [
      'bindObtain', 'bindPeriodicalObtain', 'OBTAINS', 'startObtain', 'cancelObtain',
      '__cbSuccess', '__cbError'];

   	for(var i = 0; i < props.length; i++) {
   		if( typeof destObject === 'function' ){
   			destObject.prototype[props[i]]	= Obtainer.prototype[props[i]];
   		}else{
   			destObject[props[i]] = Obtainer.prototype[props[i]];
   		}

   	}
    //destObject['_sts'] = {};

   	return destObject;
  },

}


Obtainer.prototype	= {
// bind	: function(event, fct){
//
//   var arr = bindings[event];
//
//   if ( typeof(arr) === "undefined" || arr === null ) {
//     bindings[event] = [];
//   }
//   bindings[event].push(this);
//
// },
//
// _STS(OBTAIN) {
//
//
// },
bindObtain: function(OBTAIN, cbStartup, cbSuccess, cbError) {

  if(CommonHelper.isEmpty(this.__obtains)){
      this.__obtains = {};
  }


  var sts = _STS(OBTAIN, this);

  //bind which overwrites
  // if(!CommonHelper.isEmpty(bindedObtains[OBTAIN])){
  //   this.cancelObtain(OBTAIN);
  // }

  if(CommonHelper.isNotEmpty(sts)){
    this.cancelObtain(OBTAIN);
  }


  // bindedObtains[OBTAIN] = {
  //     id:null,
  //     entranceWaitID:null,
  //     running:false,
  //     done:false,
  //     fails:0,
  //     cbStartup:cbStartup,
  //     cbSuccess:cbSuccess,
  //     cbError:cbError,
  //     periodical:false,
  //     dt:null
  //   };

    sts = {
          id:null,
          entranceWaitID:null,
          running:false,
          done:false,
          fails:0,
          cbStartup:cbStartup,
          cbSuccess:cbSuccess,
          cbError:cbError,
          periodical:false,
          dt:null
        };

    //console.log(OBTAIN);
    _setSTS(OBTAIN, this, sts);



  // switch (kind){
  //   case this.OBTAIN.ACCOUNTS:
  //   RestClient.getAccounts(cbSuccess, cbFailure)
  // }
},

bindPeriodicalObtain: function(OBTAIN, cbStartup, cbSuccess, cbError, dt) {
  this.bindObtain(OBTAIN, cbStartup, cbSuccess, cbError);
  // bindedObtains[OBTAIN].periodical = true;
  // bindedObtains[OBTAIN].dt = dt;

  var sts = _STS(OBTAIN, this);
  sts.periodical = true;
  sts.dt = dt;

},

__cbSuccess: function(OBTAIN,data){

  //
  // if(!bindedObtains[OBTAIN].periodical){
  //   this.cancelObtain(OBTAIN);
  // }
  //
  // var sts = bindedObtains[OBTAIN];
  // sts.cbSuccess(data) ;

  var sts = _STS(OBTAIN, this);

  if(!sts.periodical){
    this.cancelObtain(OBTAIN);
  }

  sts.cbSuccess(data) ;
},

__cbError: function(OBTAIN, error){

  //var sts = bindedObtains[OBTAIN];
  var sts = _STS(OBTAIN, this);

  if(!sts.periodical){
    if ((++sts.fails)>=Config.maxRestFailsCountInRow) {
      this.cancelObtain(OBTAIN);

      if (CommonHelper.isNotEmpty(sts.cbError)){
        sts.cbError(error);
      }
    }
  }else {
    if (CommonHelper.isNotEmpty(sts.cbError)){
      sts.cbError(error);
    }
  }
},

startObtain:function(OBTAIN){

  //alert(this._sts['aaa']);

  //var sts = bindedObtains[OBTAIN];
  var sts = _STS(OBTAIN, this);

  if(CommonHelper.isEmpty(sts)){
      alert('Cannot start obtain, empty:' + sts);
      return;
  }

  if (sts.running){
    //alert(OBTAIN);
    console.log(OBTAIN);
    console.log('warn:already_running');
    return ;
  }

  sts.running = true;

  sts.entranceWaitID = setInterval(() =>
  {
    if(RestClient.allowedNonEnterQueries() && ifvisible.now()){
      clearInterval(sts.entranceWaitID);
      sts.entranceWaitID = null;

      var dt = null;

      if (sts.periodical && !CommonHelper.isEmpty(sts.dt)){
        dt = sts.dt*1000;
      }else {
        dt = Config.dtBetweenRestAttempts*1000;
      }

      if(!CommonHelper.isEmpty()){
        sts.cbStartup();
      }

      switch(OBTAIN){
        case OBTAINS.ACCOUNTS:
          //console.log(obtainStatusObj.cbSuccess('22'));
          RestClient.getAccounts(
            (data)=>{this.__cbSuccess(OBTAIN, data)},
            (error)=>{this.__cbError(OBTAIN, error)});
          sts.id = setInterval(
            () => { if(!ifvisible.now()) { return ;}
            RestClient.getAccounts(
              (data)=>{this.__cbSuccess(OBTAIN, data)},
              (error)=>{this.__cbError(OBTAIN,error)});}, dt);
        break;

        case OBTAINS.STATS: {
              RestClient.stats(
                Entrance.accountId(), (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN, error)});

          sts.id = setInterval(
            () => { if(!ifvisible.now()) { return ;}
              RestClient.stats(
                Entrance.accountId(), (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN,error)});}, dt);
        }break;


        case OBTAINS.PROCESS: {
              RestClient.getLatestProcess(
                (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN, error)});

          sts.id = setInterval(
            () => { if(!ifvisible.now()) { return ;}
              RestClient.getLatestProcess(
                (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN,error)});}, dt);
        }break;

        case OBTAINS.ACCOUNT_SETS: {
              RestClient.getAccountSettings(
                (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN, error)});

          sts.id = setInterval(
            () => { if(!ifvisible.now()) { return ;}
              RestClient.getAccountSettings(
                (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN,error)});}, dt);
        }break;

        case OBTAINS.REMOVABLE_ACCOUNTS: {
            RestClient.getRemovableAccounts(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN, error)});

          sts.id = setInterval(
            () => { if(!ifvisible.now()) { return ;}
            RestClient.getRemovableAccounts(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN,error)});}, dt);
        }break;

        case OBTAINS.SHARED_DB: {
            RestClient.getSharedDb(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN, error)});

          sts.id = setInterval(
            () => { if(!ifvisible.now()) { return ;}
            RestClient.getSharedDb(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN,error)});}, dt);
        }break;

        case OBTAINS.SWITCH_SHARED_DB: {
            RestClient.switchSharedDb(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN, error)});

          sts.id = setInterval(
            () => { if(!ifvisible.now()) { return ;}
            RestClient.switchSharedDb(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN,error)});}, dt);
        }break;


        case OBTAINS.USER_TIMEZONE: {
            RestClient.getUserTimezone(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN, error)});

          sts.id = setInterval(
            () => { if(!ifvisible.now()) { return ;}
            RestClient.getUserTimezone(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN,error)});}, dt);
        }break;

        case OBTAINS.USER_INFO: {
            RestClient.currentUserInfo(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN, error)});

          sts.id = setInterval(
            () => { if(!ifvisible.now()) { return ;}
            RestClient.currentUserInfo(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN,error)});}, dt);
        }break;

        case OBTAINS.AUTOPAY_STATUS: {
            RestClient.getAutoPayStatus(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN, error)});

          sts.id = setInterval(
            () => { if(!ifvisible.now()) { return ;}
            RestClient.getAutoPayStatus(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN,error)});}, dt);
        }break;

        case OBTAINS.ACCOUNT_INFO:{
            RestClient.getAccount(Entrance.accountId(),
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN, error)});

          sts.id = setInterval(
            () => { if(!ifvisible.now()) { return ;}
            RestClient.getAccount(Entrance.accountId(),
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN,error)});}, 30000);
        }break;

        case OBTAINS.PURCHASE_ENDTIME:{
          RestClient.getPurchaseEndTime(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN, error)});

          sts.id = setInterval(
            () => { if(!ifvisible.now()) { return ;}
            RestClient.getPurchaseEndTime(
              (data)=>{this.__cbSuccess(OBTAIN, data)}, (error)=>{this.__cbError(OBTAIN,error)});}, dt);
        }break;

      }

      sts.running = false;
    }
  }, 50); // n milliseconds
},

cancelObtain(OBTAIN){

  //var sts = bindedObtains[OBTAIN];
  var sts = _STS(OBTAIN, this);

  if (CommonHelper.isEmpty(sts)){
    //    alert('warn:not_binded_nothing_to_cancel' + ' ' + OBTAIN);
    return ;
  }

  if (!CommonHelper.isEmpty(sts.entranceWaitID)){
    clearInterval(sts.entranceWaitID);
    sts.entranceWaitID = null;
  }

  if (!CommonHelper.isEmpty(sts.id)){
    clearInterval(sts.id);
    sts.id = null;
  }
},


OBTAINS() {
  return OBTAINS;
},

// unbind	: function(event, fct){
//   this._events = this._events || {};
//   if( event in this._events === false  )	return;
//   this._events[event].splice(this._events[event].indexOf(fct), 1);
// },
// trigger	: function(event /* , args... */){
//
//   var arr = bindings[event];
//
//   for (var obj of arr) {
//
//     if (arguments.length >= 1) {
//       obj[event](arguments[1]);
//     }else{
//       obj[event]();
//     }
//   }
//
// }
};


export default Obtainer;
